export const formatDate = (timestamp: number | string) =>
  new Date(timestamp).toLocaleDateString();

export const formatDateLong = (
  dateString: string | null | undefined
): string => {
  if (!dateString) return '-';

  try {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return '-';

    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '-';
  }
};
